/**
 * QL-136 — `?a=1&b=x` from a params object, skipping undefined / null / empty
 * values so an untouched filter never appears in the URL (and never busts the
 * query cache with a different key for the same request).
 */
export function toQueryString(
  params: Record<string, string | number | boolean | null | undefined>,
): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    search.set(key, String(value));
  }
  const encoded = search.toString();
  return encoded ? `?${encoded}` : "";
}
